import {
  WbBreadcrumb,
  WbBreadcrumbs,
  WbHeader,
} from '@agilelab/plugin-wb-platform';
import { RoutedTabs } from '@mainstage/core-components';
import { FC, useMemo } from 'react';
import { PermissionsTab } from './Permissions/PermissionTab';
import { RolesTab } from './Roles/RolesTab';
import { RolesPermissionsPageContextMenu } from './RolesPermissionsPageContextMenu';
import { WbPage } from '@agilelab/plugin-wb-platform';

export const RolesPermissionsPage: FC = () => {
  const routes = useMemo(() => {
    const rolesSection = {
      path: '/roles',
      title: 'Roles',
      children: <RolesTab />,
    };
    const permissionSection = {
      path: '/permissions',
      title: 'Permissions',
      children: <PermissionsTab />,
    };

    return [rolesSection, permissionSection];
  }, []);

  return (
    <WbPage themeId="home">
      <WbHeader
        pageTitleOverride="Roles & Permissions"
        title={
          <>
            Roles & Permissions <RolesPermissionsPageContextMenu />
          </>
        }
        titleContainerStyle={{ flex: 'none' }}
        breadcrumbs={
          <WbBreadcrumbs aria-label="breadcrumb">
            <WbBreadcrumb>Administration</WbBreadcrumb>
            <WbBreadcrumb>Roles & Permissions </WbBreadcrumb>
          </WbBreadcrumbs>
        }
      />

      <RoutedTabs routes={routes} />
    </WbPage>
  );
};
